import { render, staticRenderFns } from "./RegisterSteps.vue?vue&type=template&id=8ceb460a&scoped=true"
import script from "./RegisterSteps.vue?vue&type=script&lang=js"
export * from "./RegisterSteps.vue?vue&type=script&lang=js"
import style0 from "./RegisterSteps.vue?vue&type=style&index=0&id=8ceb460a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ceb460a",
  null
  
)

export default component.exports